import type EstimateValues from "../types/params"
import getInitialValue from "./getInitialValue"

const fillRestWithInitialValues = (partialValues: Partial<EstimateValues>) => {
  // 他の初期値を取得するのに必要な初期値をあらかじめ取得します。
  const {
    kibanType = getInitialValue.kibanType(),
    serviceD = getInitialValue.serviceD(),
    serviceG = getInitialValue.serviceG(),
    metalBoard = getInitialValue.metalBoard(),
    layer = getInitialValue.layer({ kibanType, metalBoard }),
    board = getInitialValue.board({ kibanType, layer }),
    minPattern = getInitialValue.minPattern(),
    hardGoldOnPCIEdgeTerminal = getInitialValue.hardGoldOnPCIEdgeTerminal(),
  } = partialValues

  const args = {
    kibanType,
    serviceD,
    serviceG,
    metalBoard,
    layer,
    board,
    minPattern,
    hardGoldOnPCIEdgeTerminal,
  }

  const returnValues = { ...partialValues } as EstimateValues

  const keys = Object.keys(getInitialValue) as (keyof EstimateValues)[]
  for (const key of keys) {
    // 型の解決が難しいので仕方なくanyにして代入してます。
    ;(returnValues as any)[key] ??= getInitialValue[key](args)
  }

  return returnValues
}

export default fillRestWithInitialValues
